/**
 * Set Roles list.
 *
 * @param state
 * @param payload
 */
export function ROLES(state, payload) {
  state.roles = payload.data;
}

/**
 * Set Role.
 *
 * @param state
 * @param payload
 */
export function ROLE(state, payload) {
  state.role = payload.data;
}